import { render, staticRenderFns } from "./PerfFilterBar.vue?vue&type=template&id=68216272&"
import script from "./PerfFilterBar.vue?vue&type=script&lang=js&"
export * from "./PerfFilterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports